<template>

	<dl class="sort-item"
		v-if="!(ptInitData.siteKbn == '4' && !ptInitData.loginKbn && ptInitData.priceShowBtoB == 0) && ptInitData.priceShow != 1">
		<dt class="pointInfo"
			v-if="(ptInitData.productInfo.POINT_ITEM_KBN == '0' || ptInitData.productInfo.POINT_ITEM_KBN == '2')">
			<span class="pointNum" v-if="(ptInitData.productInfo.POINT_NUM > 0)">
				{{ formatPrice(ptInitData.productInfo.POINT_NUM) }}{{ $t('common.labels.pointGrantNum') }}
			</span>
			<span class="pointCampaign" v-if="(ptInitData.productInfo.PROMO_POINT_NUM > 0)">
				<span class="pointGrantCampaign" v-if="(ptInitData.productInfo.POINT_NUM > 0)">
					<!-- 更に○○ポイント付与 -->
					<br>{{ $t('common.labels.pointGrantCampaign') }}
				</span>
				{{ formatPrice(ptInitData.productInfo.PROMO_POINT_NUM) }}{{ $t('common.labels.pointGrantNum') }}
			</span>
		</dt>
	</dl>
</template>
<script>
import common from "assets/js/common"; 
export default {
	methods: {
		/**
		 * format number value to currency value
		 * @param {number} value, number to format
		 */
		formatPrice: function (value) {
			return common.formatPrice(value);
		},
	},
	name: 'point',
	props: {
		ptInitData: {
			type: Object,
			default: null,
		}
	}
}
</script>
